import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';

const IFrame = styled.iframe`
  border: 0;
`;

const embedVideoPropertyTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
};

type EmbedVideoProperties = InferProps<typeof embedVideoPropertyTypes>;

const EmbedVideo = ({
  src, title, width, height,
}: EmbedVideoProperties) => (
  <IFrame
    width={width ?? '100%'}
    height={height ?? '315'}
    src={src}
    allowFullScreen
    title={title}
  />
);

EmbedVideo.propTypes = embedVideoPropertyTypes;

export default EmbedVideo;
